// Declara el tipo correcto para window.clarity
interface ClarityFunc extends Function {
  q?: any[];
}

declare global {
  interface Window {
    clarity: ClarityFunc;
  }
}

export default () => {
  if (process.client) {
    (function(c: any, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Node) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r) as HTMLScriptElement; t.async = true; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode!.insertBefore(t, y);
    })(window, document, "clarity", "script", "sbpg6das5u");
  }
};